<script setup lang="ts">
</script>

<template>
  <div class="flex flex-col items-center justify-center py-20">
    <p class="text-2xl text-muted-foreground animate-bounce">博主很懒，还没给我喂饭</p>
    <div class="text-6xl mt-4 animate-swing">🍚</div>
  </div>
</template>
